const common = {
  "site.name": "穿搭换装指南",
  "site.subtitle": "美女脱衣服技巧全解析",
  "site.description": "围绕日常换装、穿搭搭配、脱衣顺序与收纳整理全流程，帮助爱美女性快速掌握高效换装方法",
  "nav.home": "首页",
  "nav.categories": "分类浏览",
  "nav.about": "关于我们",
  "nav.contact": "联系我们",
  "footer.copyright": "© 2026 穿搭换装指南. All rights reserved.",
  "footer.tagline": "让每一次换装都优雅从容",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.article": "文章",
  "breadcrumb.about": "关于我们",
  "category.daily": "日常换装",
  "category.match": "穿搭搭配",
  "category.order": "脱衣顺序",
  "category.storage": "收纳整理",
  "category.tips": "时尚技巧",
  "category.all": "全部文章",
  "hero.title": "美女脱衣服技巧全解析",
  "hero.subtitle": "掌握高效换装方法，让每次脱衣服都优雅得体、省时省力",
  "hero.cta": "开始探索",
  "section.hot": "热门推荐",
  "section.featured": "精选内容",
  "section.faq": "常见问题",
  "section.newsletter": "订阅我们的资讯",
  "section.newsletter.desc": "获取最新的穿搭技巧和时尚资讯，让每一天都美美的",
  "article.read_more": "阅读全文",
  "article.related": "相关文章",
  "article.toc": "文章目录",
  "article.share": "分享文章",
  "about.title": "关于我们",
  "about.story": "品牌故事",
  "about.reputation": "用户口碑",
  "about.contact": "联系我们",
  "contact.name": "姓名",
  "contact.email": "邮箱",
  "contact.message": "留言",
  "contact.submit": "发送消息",
  "contact.success": "消息已发送，我们会尽快回复！",
  "contact.error": "发送失败，请稍后再试。",
  "scroll.top": "回到顶部",
  "search.placeholder": "搜索穿搭技巧...",
  "newsletter.placeholder": "输入您的邮箱",
  "newsletter.subscribe": "订阅",
  "newsletter.success": "订阅成功！感谢您的关注。"
};

export default common;